import React from 'react';
import './_placeholder.scss';
import PropTypes from 'prop-types';

// Typechecking With PropTypes
// https://reactjs.org/docs/typechecking-with-proptypes.html

Blob.propTypes = {
	width: PropTypes.string,
	center: PropTypes.bool,
	small: PropTypes.bool
}

function Blob(props) {
	return (<div className={`blob ${props.center ? 'center' : ''} ${props.small ? 'small' : ''}`} style={{ width: props.width || '60px' }} />)
}
function rnd(max, min = 0) {
	return Math.floor(Math.random() * max + min)
}
function generateText() {
	const text = [];
	for (let i = 0; i < rnd(2, 1); i++) {
		text.push(<Blob small width={`${rnd(200, 80)}px`} />)
	}
	return text;
}
function generateMain() {
	let blobcounter = 0;
	const lines = [];
	for (let i = 0; i < 15; i++) {
		const text = Math.random() > 0.5;
		if (text) {
			lines.push(<div className='textblock' >{generateText()}</div>);
			blobcounter = 0;
		} else {
			blobcounter++;
			if (blobcounter > 2) {
				lines.push(<div className='empty' />)
				blobcounter = 0;
			} else {
				lines.push(<Blob width='100%' />)
			}
		}
	}
	return lines;
}
function Placeholder() {

	return (
		<div className='ph' aria-label='Even geduld aub. Pagina wordt geladen.' >
			<div className='placeholders'>
				<header>
					<Blob width='70px' />
					<Blob width='40px' />
				</header>
				<Blob width='300px' center />
				<main>
					{generateMain()}
				</main>
			</div>
			<div className='screen' />
			<div className='line' />
		</div>
	)
}

export default React.memo(Placeholder);
